import { Text } from "@mantine/core";

import type { CustomerLoveMetricsView } from "../data/types";

import customerLoveIcon from "./assets/customerLoveIcon.png";
import styles from "./cardContent.module.css";
import { computeDirectRingFill } from "./computeRingFill";
import { MetricCard } from "./MetricCard";
import { RingArt } from "./RingArt";
import { CUSTOMER_LOVE_ERP_TARGET, CUSTOMER_LOVE_GRADIENT } from "./targets";

interface Props {
    view: CustomerLoveMetricsView;
}

export function CustomerLoveCard({ view }: Props) {
    const rating = view.yesterdayRating;
    const hasRating = rating !== null;
    const ringProgress = hasRating ? computeDirectRingFill(rating, CUSTOMER_LOVE_ERP_TARGET) : 0;

    return (
        <MetricCard
            title="Customer love"
            isLoading={view.isLoading}
            isEmpty={!hasRating}
            emptyValue="No reviews yesterday."
            art={
                <RingArt progress={ringProgress} gradient={CUSTOMER_LOVE_GRADIENT} isLoading={view.isLoading}>
                    <img src={customerLoveIcon} alt="" className={styles.icon} />
                </RingArt>
            }
            value={
                <Text component="span" className={styles.bigNumber}>
                    {rating?.toFixed(1)}
                </Text>
            }
            footer={
                <>
                    ERP target <strong>({CUSTOMER_LOVE_ERP_TARGET})</strong>
                </>
            }
        />
    );
}
